import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { UiSchemaCollection } from "@vp/formly/ui-schema-config";
import { CacheService } from "@vp/shared/services/cache";
import { API_BASE_URL } from "@vp/shared/tokens";

import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class UiSchemaApiService {
  constructor(
    @Inject(API_BASE_URL) private apiBaseUrl: string,
    private cacheService: CacheService<UiSchemaCollection[]>,
    private http: HttpClient
  ) {}

  get = (): Observable<UiSchemaCollection[]> => {
    if (!this.cacheService.has("UiSchemaApiService.get")) {
      return this.getInternal().pipe(
        tap(uiSchemas => {
          this.cacheService.set("UiSchemaApiService.get", uiSchemas);
        })
      );
    }
    return this.cacheService.get("UiSchemaApiService.get", this.getInternal());
  };

  private getInternal = () => {
    return this.http.get<UiSchemaCollection[]>(`${this.apiBaseUrl}/uischemas`);
  };
}
